<script lang="ts">
  import api from '../api/api'
  import {user} from '../stores/user'
  import {t} from '../i18n'
  import {flash} from '../stores/flash'

  export let newPasswords = {password: '', password_confirmation: ''}
  let passwordConfirmationInput: HTMLInputElement

  function validate() {
    if (newPasswords.password === newPasswords.password_confirmation) {
      passwordConfirmationInput.setCustomValidity('')
      return true
    } else {
      passwordConfirmationInput.setCustomValidity(t.errors.validation.password_matches)
      return false
    }
  }

  async function submit(e: Event) {
    e.preventDefault()
    if (!validate()) return

    await api.put(`/users/${$user?.id}`, {user: newPasswords})
    newPasswords = {password: '', password_confirmation: ''}
    flash.show(t.flash.reset_password.success)
  }
</script>

<form onsubmit={submit} class="grid three">
  <div class="grid__item">
    <div class="line">
      <input type="password" id="password" bind:value={newPasswords.password} placeholder={t.reset_password.password}
             required minlength={6} maxlength={255} autocomplete="off"/>
    </div>
  </div>
  <div class="grid__item">
    <div class="line">
      <input type="password" id="password_confirmation" placeholder={t.reset_password.password_confirmation}
             bind:value={newPasswords.password_confirmation}
             required bind:this={passwordConfirmationInput} autocomplete="off"
             oninput={() => passwordConfirmationInput.setCustomValidity('')}/>
    </div>
  </div>

  <div class="grid__item">
    <button type="submit" class="ui button black connected">{t.reset_password.submit}</button>
  </div>
</form>
